




































































































import { Component, Vue, Emit, Watch } from 'vue-property-decorator'
import { Procedimento } from '@/types/_'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'
import _ from 'lodash'
import EventBus from '@/plugins/EventBus'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'

@Component

export default class ComponentModalSolicitacaoCirurgiaProcedimento extends Vue {
  inputSearch: string = ''
  loading: any = {
    searchProcedimento: false,
    listText: '',
  }

  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get getRequestMessage() {
    return this.getSolicitacaoStore.requestMessage
  }

  get getProcedimentosApi() {
    return this.getSolicitacaoStore.procedimentosApi
  }

  get getInputSearch() {
    return this.inputSearch
  }

  set getInputSearch(value) {
    this.inputSearch = value
  }

  get getShowModalProcedimento() {
    return this.getSolicitacaoStore.modalSolicitacaoCirurgia.showProcedimentoPrincipal
  }

  get getProcedimento() {
    return this.getSolicitacaoStore.solicitacao.procedimento
  }

  @Watch('getShowModalProcedimento')
  async onChangeGetShowModalProcedimento(value) {
    setTimeout(() => {
      const input = document.querySelector('.procedimento-input input') as HTMLInputElement
      if (value) {
        this.getInputSearch = ''
        input.focus()
      } else {
        input.blur()
      }
    }, 100)
  }

  save() {
    this.getInputSearch = ''
    this.getSolicitacaoStore.showModalProcedimentoPrincipal(false)
  }

  closeModalProcedimentoPrincipal() {
    this.getSolicitacaoStore.showModalProcedimentoPrincipal(false)
  }

  async selectProcedimento(data: Procedimento) {
    if (data.tecnicasDoProcedimento && !!data.tecnicasDoProcedimento.length) {
      this.getSolicitacaoStore.setTecnicasDisponiveis(data.tecnicasDoProcedimento)
    }

    const res = await this.getSolicitacaoCirurgiaStore.checkExistProtocoloParaOProcedimento(data)
    if (!res) {
      this.addProcedimentoQuantidade(data)
    }
  }

  async addProcedimentoQuantidade(procedimento: Procedimento) {
    this.getSolicitacaoCirurgiaStore.addProcedimentoQuantidade(procedimento)
  }

  async verificarCoberturaVigente(procedimento: Procedimento) {
    const { hospital } = this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia
    if (!hospital.hospitalFazConsultaCoberturaVigente || hospital.tipoDeCoberturaVigente !== 'Procedimento') return

    const request = await this.getSolicitacaoCirurgiaStore.consultaCoberturaVigente(procedimento.id)
    if (request.success) this.getSolicitacaoStore.setProcedimentoPrincipalCoberturaVigente({ ...procedimento, coberturaVigente: request.data.temCoberturaVigente })
  }

  async addSelectedPrincipalEventFromModalQuantidade(data: Procedimento) {
    const { procedimento } = this.getSolicitacaoStore.solicitacao
    if (procedimento && procedimento.id) this.getSolicitacaoStore.setProcedimentoApi(procedimento)
    // this.getSolicitacaoStore.setProcedimentoPrincipal({ ...data, tempoCirurgicoMinimoEmMinutos: 30 })
    this.getSolicitacaoStore.setProcedimentoPrincipal(data)

    if (
      this.getSolicitacaoStore.solicitacao.procedimento
      && this.getSolicitacaoStore.solicitacao.procedimento.tempoCirurgicoMinimoEmMinutos
    ) {
      this.getSolicitacaoCirurgiaStore.setSolicitacaoCirurgiaFields({
        field: 'tempoCirurgia',
        value: this.getSolicitacaoStore.solicitacao.procedimento.tempoCirurgicoMinimoEmMinutos,
      })
    }

    await this.verificarCoberturaVigente(data)
    this.getSolicitacaoStore.removeProcedimentoApi(data)
  }

  async removeProcedimento(procedimento) {
    const proc = { ...procedimento }
    const { solicitacao } = this.getSolicitacaoStore
    // Reset tempo de cirurgia...
    if (solicitacao.procedimento && solicitacao.procedimento.tempoCirurgicoMinimoEmMinutos) {
      this.getSolicitacaoCirurgiaStore.setSolicitacaoCirurgiaFields({ field: 'tempoCirurgia', value: 0 })
    }
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.deleteMessage })
    await this.getSolicitacaoStore.deleteProcedimentoPrincipal()
    this.getSolicitacaoStore.setProcedimentoApi(proc)
    this.getSolicitacaoCirurgiaStore.checkNeedRejectOrRemoveProtocoloByProcedimentoPrincipalChange()
    EventBus.$emit('clearLoadingRequest')
  }

  debounce = _.debounce(input => this.getSolicitacaoStore.getProcedimentoSearch(input), 600)

  search() {
    if (this.getInputSearch.length === 0 || this.getInputSearch.length > 2) {
      this.debounce(this.getInputSearch)
    }
  }

  get getSolicitacaoCirurgiaStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }
}

